/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Routes } from 'react-router';

import { SkipNavContent, ErrorBoundary } from 'sarsaparilla';
import { Footer } from 'site-kit';

import { ExternalPageFrame } from 'shared-ui/external-app-base';
import ErrorPage from 'shared-ui/components/ErrorPage/ErrorPage';
import { TopNavigationExternal } from 'shared-ui/TopNavigationExternal';
import { gnoment } from 'shared-ui/gnoment';

import makeSwitchRoutes from './makeSwitchRoutes';

gnoment.tz.setDefault('UTC');

export default function App() {
    return (
        <ExternalPageFrame>
            <TopNavigationExternal />

            <ErrorBoundary fallbackElement={<ErrorPage />}>
                <SkipNavContent className="rec-page">
                    <Routes>{makeSwitchRoutes()}</Routes>
                </SkipNavContent>
            </ErrorBoundary>

            <Footer />
        </ExternalPageFrame>
    );
}

if (process.env.REACT_AXE_ENV === 'local') {
    // eslint-disable-next-line
    const { default: axe } = await import('@axe-core/react');
    axe(React, ReactDOM, 5000);
}
